import { render, staticRenderFns } from "./RsaSchedaPsicologicaModalEditComponent.vue?vue&type=template&id=2011404c"
import script from "./RsaSchedaPsicologicaModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPsicologicaModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports